import { Injectable } from '@angular/core';
import { gql, Query } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class StartToMarkRegCompleteAsyncEdgeGraphqlService extends Query<any> {
  document = gql`
    query StartToMarkRegCompleteAsyncEdge {
      patient {
        id
        isSeniorHealthPatient
      }
    }
  `;
}
